module.exports = __webpack_public_path__ + "static/media/fHIPOTECA ABIERTA SIN LIMITE DE CUANTIA ELLOS A EL MINUTA.70b0241c.pdf";